<template>
	<div class="navbar">
		<hamburger id="hamburger-container" :is-active="getters.sidebar.opened" class="hamburger-container" @toggleClick="toggleSideBar" />
		<breadcrumb id="breadcrumb-container" class="breadcrumb-container" v-if="!$store.state.settings.topNav" />
		<top-nav id="topmenu-container" class="topmenu-container" v-if="$store.state.settings.topNav" />
		<!-- 顶部右侧菜单 -->
		<div class="right-menu">
			<template v-if="getters.device !== 'mobile'">
				<header-search id="header-search" class="right-menu-item" />
				<screenfull id="screenfull" class="right-menu-item hover-effect" />
				<el-tooltip content="布局大小" effect="dark" placement="bottom">
					<size-select id="size-select" class="right-menu-item hover-effect" />
				</el-tooltip>
				<el-dropdown class="el-dropdown-link right-menu-item" trigger="click" @command="handlerSysType">
					<div class="subSystemList">
						<span class="m2">
							<svg-icon v-if="activeSystemIcon" :icon-class="activeSystemIcon" />
							{{ activeSystemName }}
						</span>
						(
						<span class="text-red fz12">切换</span>
						)
						<i class="el-icon-arrow-down el-icon--right" />
					</div>
					<template #dropdown>
						<el-dropdown-menu>
							<a v-for="item in subSystemList" :key="item.Id" href="#">
								<el-dropdown-item :command="item.EnCode">
									<span :class="activeSystemName == item.FullName ? 'm1' : 'm0'">
										<svg-icon v-if="item.Icon" :icon-class="item.Icon" />
										{{ item.FullName }}
									</span>
								</el-dropdown-item>
							</a>
						</el-dropdown-menu>
					</template>
				</el-dropdown>
			</template>
			<div class="avatar-container">
				<el-dropdown @command="handleCommand" class="right-menu-item hover-effect" trigger="click">
					<div class="avatar-wrapper">
						<img :src="userAvatar" :alt="userAccount" class="user-avatar" />
						<el-icon>
							<caret-bottom />
						</el-icon>
					</div>
					<template #dropdown>
						<el-dropdown-menu>
							<router-link to="/user/center/index">
								<el-dropdown-item>个人中心</el-dropdown-item>
							</router-link>
							<el-dropdown-item command="setLayout">
								<span>布局设置</span>
							</el-dropdown-item>
							<el-dropdown-item command="modify">
								<span @click="showModify()">修改密码</span>
							</el-dropdown-item>
							<el-dropdown-item divided command="logout">
								<span>退出登录</span>
							</el-dropdown-item>
						</el-dropdown-menu>
					</template>
				</el-dropdown>
			</div>
		</div>
		<!-- 修改密码弹窗 -->
		<el-dialog ref="dialogModify" title="修改密码" v-model="dialogModifyVisible" width="600px" draggable>
			<Modify ref="modifyDialog" />
			<template #footer>
				<div class="dialogfooter">
					<el-button type="primary" @click="saveEditForm()">保 存</el-button>
					<el-button @click="onClose()">取 消</el-button>
				</div>
			</template>
		</el-dialog>
	</div>
</template>

<script setup>
import { ElMessageBox } from 'element-plus'

import { scmConnecSys } from '@/api/basebasic'

import TopNav from '@/components/TopNav'
import Breadcrumb from '@/components/Breadcrumb'
import Hamburger from '@/components/Hamburger'
import Screenfull from '@/components/Screenfull'
import SizeSelect from '@/components/SizeSelect'
import HeaderSearch from '@/components/HeaderSearch'

import Modify from '@/views/user/center/modify.vue'

const emits = defineEmits(['setLayout', 'modify'])

const store = useStore()

const getters = computed(() => store.getters)

const activeSystemName = store.getters.activeSystemName
const activeSystemIcon = store.getters.activeSystemIcon
const subSystemList = store.getters.subSystemList
const userAvatar = store.getters.avatar
const userAccount = store.getters.name

const dialogModifyVisible = ref(false)
const modifyDialog = ref()

function setLayout() {
	emits('setLayout')
}
function modify() {
	emits('modify')
}

function toggleSideBar() {
	store.dispatch('app/toggleSideBar')
}
/**
 * 关闭修改对话框
 */
function onClose() {
	dialogModifyVisible.value = false
}
/**
 * 显示修改对话框
 */
function showModify() {
	dialogModifyVisible.value = true
}

/**
 * 修改保存
 */
function saveEditForm() {
	modifyDialog.value.saveEditForm(onClose)
}

/**
 * 事件
 */
function handleCommand(command) {
	switch (command) {
		case 'setLayout':
			setLayout()
			break
		case 'modify':
			modify()
			break
		case 'logout':
			logout()
			break
		default:
			break
	}
}
/**
 * 注销并退出
 */
function logout() {
	ElMessageBox.confirm('您确定注销并退出系统吗？', '登出提示', {
		confirmButtonText: '确定',
		cancelButtonText: '取消',
		type: 'warning'
	})
		.then(() => {
			store.dispatch('LogOut').then(() => {
				location.href = '/index'
			})
		})
		.catch(() => {})
}
/**
 * 切换系统
 */
function handlerSysType(command) {
	var param = {
		systype: command
	}
	scmConnecSys(param).then((res) => {
		if (res && res.Success) {
			window.location.href = res.ResData
		}
	})
}
</script>

<style scoped lang="scss">
.navbar {
	height: 50px;
	overflow: hidden;
	position: relative;
	background: #fff;
	box-shadow: 0 1px 4px rgba(0, 21, 41, 0.08);

	.hamburger-container {
		line-height: 46px;
		height: 100%;
		float: left;
		cursor: pointer;
		transition: background 0.3s;
		-webkit-tap-highlight-color: transparent;

		&:hover {
			background: rgba(0, 0, 0, 0.025);
		}
	}

	.breadcrumb-container {
		float: left;
	}

	.topmenu-container {
		position: absolute;
		left: 50px;
	}

	.errLog-container {
		display: inline-block;
		vertical-align: top;
	}

	.right-menu {
		float: right;
		height: 100%;
		line-height: 50px;
		display: flex;

		&:focus {
			outline: none;
		}

		.el-dropdown-link {
			cursor: pointer;
		}

		.subSystemList {
			font-size: 14px;
			vertical-align: middle;
			line-height: 40px;
			margin-top: 6px;
		}

		.right-menu-item {
			display: inline-block;
			padding: 0 8px;
			height: 100%;
			font-size: 18px;
			color: #5a5e66;
			vertical-align: text-bottom;

			&.hover-effect {
				cursor: pointer;
				transition: background 0.3s;

				&:hover {
					background: rgba(0, 0, 0, 0.025);
				}
			}

			.iconbuju {
				margin-right: 10px;
			}

			.bujutitle {
				margin-left: 10px;
			}
		}

		.avatar-container {
			margin-right: 40px;

			.avatar-wrapper {
				margin-top: 5px;
				position: relative;

				.user-avatar {
					cursor: pointer;
					width: 40px;
					height: 40px;
					border-radius: 10px;
				}

				i {
					cursor: pointer;
					position: absolute;
					right: -20px;
					top: 25px;
					font-size: 12px;
				}
			}
		}
	}
}

.dialogfooter {
	width: 100%;
	display: flex;
	justify-content: flex-end;
}
.m2 {
	color: rgb(64, 158, 255);
	margin-right: 2px;
}
.m1 {
	color: red;
}
.m0 {
	color: rgb(93, 93, 93);
}
</style>
